import { TimeClockType } from 'models'

export enum TotalHourType {
    WORK = 'WORK',
    BREAK = 'BREAK',
    MEAL_BREAK = 'MEAL_BREAK',
}

export const enableTimeClockMenuLogic = (
    type: TimeClockType,
    lastType: TimeClockType,
) => {
    if (lastType === TimeClockType.ClockOut) {
        if (type === TimeClockType.ClockIn) return true
    }

    if (
        lastType === TimeClockType.ClockIn ||
        lastType === TimeClockType.EndBreak ||
        lastType === TimeClockType.EndMealBreak
    ) {
        if (
            type === TimeClockType.ClockOut ||
            type === TimeClockType.StartBreak ||
            type === TimeClockType.StartMealBreak
        ) {
            return true
        }
    }

    if (lastType === TimeClockType.StartBreak) {
        if (type === TimeClockType.ClockOut || type === TimeClockType.EndBreak)
            return true
    }

    if (lastType === TimeClockType.StartMealBreak) {
        if (
            type === TimeClockType.ClockOut ||
            type === TimeClockType.EndMealBreak
        )
            return true
    }

    return false
}

/**
 * Should counting time logic while Break, MealBreak or WorkTimes
 * for avoiding spams requests to get time total with real-time
 * @param type TotalHourType
 * @param lastType TimeClockType
 */
export const countingTotalHourLogic = (
    type: TotalHourType,
    lastType: TimeClockType,
) => {
    if (type === TotalHourType.WORK) {
        if (
            lastType === TimeClockType.ClockOut ||
            lastType === TimeClockType.StartBreak ||
            lastType === TimeClockType.StartMealBreak
        ) {
            return false
        }
    }

    if (type === TotalHourType.BREAK) {
        if (lastType !== TimeClockType.StartBreak) {
            return false
        }
    }

    if (type === TotalHourType.MEAL_BREAK) {
        if (lastType !== TimeClockType.StartMealBreak) {
            return false
        }
    }

    return true
}
